<template>
  <div class="index">
    页面不存在
  </div>
</template>


<script>
export default {
  name: 'Fail',

  data() {
    return {
      currentRoutePath: "/product"
    }
  },
  methods: {

  },

  //自动触发写入的函数
  mounted: function () {
  }
}

</script>

<style>
</style>